import React, { FC } from 'react';
import DashboardShowAll from './components/DashboardShowAll';

interface DashboardShowAllScreenProps {}

const DashboardShowAllScreen: FC<DashboardShowAllScreenProps> = () => {
  return <DashboardShowAll />;
};

export default DashboardShowAllScreen;
